import FloatingUiController from '../../../javascript/overlays/controllers/floating_ui'

export default class TooltipController extends FloatingUiController {
  displayPopup() {
    this.popupTarget.setAttribute('data-show', '')
  }

  hidePopup() {
    this.popupTarget.removeAttribute('data-show')
  }
}
